import {
  AfterContentInit,
  AfterViewInit,
  ContentChildren,
  Directive,
  HostBinding,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from '@angular/core';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccordionSectionComponent } from './accordion-section.component';

@Directive({ selector: '[psUiAccordion], ps-ui-accordion' })
export class AccordionDirective implements AfterContentInit, AfterViewInit {
  /** If true only one section can be open at once */
  @Input() closeOthers = false;
  @Output() readonly toggle = new EventEmitter();

  private _arrowToggleOnly = false;
  /** If true the section can only be opened by clicking the arrow on the side */
  @Input()
  set arrowToggleOnly(toggle: boolean) {
    this._arrowToggleOnly = toggle;
    if (this.sections) {
      this._updateArrowToggleOnlyOnSections();
    }
  }

  @HostBinding('class') defaultClass = 'accordion';

  @ContentChildren(AccordionSectionComponent)
  sections!: QueryList<AccordionSectionComponent>;

  ngAfterContentInit(): void {
    this._updateArrowToggleOnlyOnSections();
  }

  ngAfterViewInit(): void {
    // Subscribe to all sections toggled status so we can
    // close the others if closeOthers is set to true
    const obs = this.sections.map((section, index) => {
      return section.segmentToggled.pipe(map((opened) => ({ index, opened })));
    });

    merge(...obs).subscribe((update: SectionToggleInfo) => {
      if (update.opened && this.closeOthers) {
        this.sections.forEach((section, i) => {
          if (update.index !== i) {
            section.close();
          }
        });
      }
      this.toggle.emit(update);
    });
  }

  private _updateArrowToggleOnlyOnSections() {
    this.sections.forEach(
      (section) => (section.arrowToggleOnly = this._arrowToggleOnly)
    );
  }
}

export interface SectionToggleInfo {
  index: number;
  opened: boolean;
}
